export const sprintf = function () {
  let counter = 1;
  const args = arguments;

  return args[0].replace(/%s/g, function () {
    return args[counter++];
  });
};
